import {TourSteps} from './interface/tour-steps.interface';
import Step from 'shepherd.js/src/types/step';

export const registerFoodDishMenuStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'openModule',
        title: 'Agregar nueva receta',
        text: `Da clic en el botón para abrir el formulario de registro.`,
        attachTo: {
          element: '.btn-add-food-dish',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-add-food-dish',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      }
    ];
  };
